import React from "react";

import { Card, Stack, Typography } from "@mui/material";

import EditSharedEpisodeDialog from "./components/EditSharedEpisodeDialog";
import { SharedEpisode } from "./services/shared-episodes.service";
import ListOfSharedEpisodes from "./components/ListOfSharedEpisodes";
import AppLayout from "../common/AppLayout";

export default function SharedEpisodesView() {
  const [
    showEditSharedEpisodeDialogForSharedEpisode,
    setShowEditSharedEpisodeDialogForSharedEpisode,
  ] = React.useState<SharedEpisode | null>(null);

  const handleOpenEditSharedEpisodeDialog = (sharedEpisode: SharedEpisode) => {
    setShowEditSharedEpisodeDialogForSharedEpisode(sharedEpisode);
  };

  const handleCloseEditSharedEpisodeDialog = () => {
    setShowEditSharedEpisodeDialogForSharedEpisode(null);
  };

  return (
    <AppLayout pageName="Shared Episodes" maxWidth={false}>
      {!!showEditSharedEpisodeDialogForSharedEpisode && (
        <EditSharedEpisodeDialog
          open={!!EditSharedEpisodeDialog}
          handleClose={handleCloseEditSharedEpisodeDialog}
          sharedEpisode={showEditSharedEpisodeDialogForSharedEpisode}
        />
      )}
      <Card
        component={Stack}
        spacing={0}
        direction="column"
        sx={{ position: "relative", px: 4, py: 4, borderRadius: 2 }}
      >
        <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
          List of Shared Episodes
        </Typography>
        <ListOfSharedEpisodes
          handleOpenEditSharedEpisodeDialog={handleOpenEditSharedEpisodeDialog}
        />
      </Card>
    </AppLayout>
  );
}
